import React, { FunctionComponent } from 'react';
import Footer from '#components/Footer';
import BottomSearchSection from '../BottomSearchSection';
import Article from '../Landing/Article';
import IndustryCatalogue from './IndustryCatalogue';
import useStyles from './styles';

const IndustryDirectory: FunctionComponent = () => {
  const styles = useStyles();

  return (
    <>
      <IndustryCatalogue />
      <div className={styles.sectionArticle}>
        <Article />
      </div>
      <BottomSearchSection />
      <Footer />
    </>
  );
};

export default IndustryDirectory;
